import { render, staticRenderFns } from "./PageLink.vue?vue&type=template&id=9c20b268&"
import script from "./PageLink.vue?vue&type=script&lang=js&"
export * from "./PageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports